module.exports = __webpack_public_path__ + "static/media/upload-visuals.d2d9cb02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/upload-visuals.png
// module id = 379
// module chunks = 3